import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { HttpStateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { DspsNormalisedEntities } from "../models";

const actionCreator = actionCreatorFactory.default();

export const requestDspsIndex = actionCreator<{}>(actionTypes.INDEX_REQUEST);
export const dspsIndexSuccess = actionCreator<NormalisedResult<number[], DspsNormalisedEntities>>(
    actionTypes.INDEX_SUCCESS,
);
export const dspsIndexFailure = actionCreator<HttpStateError>(actionTypes.INDEX_FAILURE);

export type DspsAction = Action<{}> | Action<HttpStateError> |
    Action<NormalisedResult<number[], DspsNormalisedEntities>>;
